import {
    EVENT_SERVICE,
} from "./../../providers/service.providers";
import { EventService } from "../../services/event.service";
import {
    Component,
    OnInit,
    Inject,
    OnDestroy
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Event } from "../../models/Event";
import { ImageHelper } from "../../helpers/ImageHelper";
import { environment } from "./../../../environments/environment";
import { LabelsService } from "src/app/services/labels.service";
import { SessionCartService } from "./session-cart/session-cart.service";
import { Session } from "src/app/models/Session";
import { ActiveEventService } from "src/app/services/active-event.service";
import { LocalizableError } from 'src/app/models/LocalizableError';
import { EventCheckoutRoutePaths } from "../eventregistration/eventregistration.component";
import { DatePipe } from '@angular/common';
import { DateFormatter } from 'src/app/helpers/DateFormatter';
import { EventRouterService } from 'src/app/services/event-router.service';
import { Subscription,fromEvent } from 'rxjs';
import { CustomregistrationfieldsService } from '../../services/customregistrationfields.service';

@Component({
    selector: "app-event",
    templateUrl: "./event.component.html",
    styleUrls: ["./event.component.scss"]
})
export class EventComponent implements OnInit, OnDestroy {
    public EventDetailSections = EventDetailSections;
    public readableEventId: string;
    public event: Event;
    public sessions: Session[];
    public showSessions: Boolean;
    public showSpeakers: Boolean;
    public showSessionTracks: Boolean;
    public showPasses: Boolean;
    public selectedSection: EventDetailSections = EventDetailSections.Sessions;
    public isSessionCartCollapsed: Boolean = false;
    public isSessionCartAllowed: Boolean = false;
    public isLoadDateAndDescription: Boolean = false;
    public isLoadingData = false;
    public isLoadingBtn =true;
    public error: LocalizableError;
    public formattedDate: string;
    public url: string;
    public sourceUrl:string;
    private defaultImageUrlSelfHosted = 'default-event-image.jpg';
    private defaultImageUrlCrmHosted = 'homehero.jpg';
    private dataPromise: Promise<any>;

    private eventRouterSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        @Inject(EVENT_SERVICE) private eventService: EventService,
        private eventRouterService: EventRouterService,
        private imageHelper: ImageHelper,
        private labelsService: LabelsService,
        private sessionCartService: SessionCartService,
        private activeEventService: ActiveEventService,
        private datePipe: DatePipe,
        private customregistrationfieldservice: CustomregistrationfieldsService,
    ) {

     }

    ngOnDestroy(): void {
        this.eventRouterSubscription.unsubscribe();
    }

    async ngOnInit() {
        this.eventRouterSubscription = this.eventRouterService.choosePath$.subscribe(() => {
            this.chooseRoute();
        })
        this.route.queryParamMap.subscribe(paramMap => {
            this.readableEventId = paramMap.get(
                EventQueryParameterNames.ReadableEventId
            );
                this.dataPromise = this.getEventAndSessionData().then(async () => {
                const p4 = this.setIsSessionCartAllowed();
                const p3 = this.setIsLoadDateAndDescription();
                const p2 = this.eventService.getSpeakers(this.readableEventId).toPromise().then(
                    speakers => {
                        this.showSpeakers = speakers && speakers.length > 0;
                        this.eventRouterService.emitSpeakers(speakers);
                    }
                );
                Promise.all([ p2])
                this.router.navigate(["event/sessions"], { queryParams: { id: this.readableEventId} });
            });
        });

        this.sessionCartService.isOpen = false;
        this.url=this.splitUrl();
        this.isLoadingBtn=false;

        window.localStorage.setItem('backUrl',window.location.href);
    }


    public getconfirmtext() {
        this.customregistrationfieldservice.url = this.url;
        this.customregistrationfieldservice.customfieldbus.emit({
            type: "string", msg: this.url
        })
    }
    public chooseRoute() {
        this.dataPromise.then(p => {
            if (this.showSessions) {
                this.router.navigate(["event/sessions"], { queryParams: { id: this.readableEventId } });
            } else if (this.showSessionTracks) {
                this.router.navigate(["event/session-tracks"], { queryParams: { id: this.readableEventId } });
            } else if (this.showSpeakers) {
                this.router.navigate(["event/speakers"], { queryParams: { id: this.readableEventId } });
            } else if (this.showPasses) {
                this.router.navigate(["event/pass-information"], { queryParams: { id: this.readableEventId } });
            }
        })
    }

    public formatStartDate(): string {
        let dateSettings = DateFormatter.getDateSettings();

        if (dateSettings.convertToLocalDate) {
            return DateFormatter.formatSingeDate(this.datePipe, this.event.startDateUTC);
        }
        else {
            return DateFormatter.formatSingeDate(this.datePipe, this.event.startDate);
        }
    }

    public getBannerImage() {
        if (this.event == null) {
            // This early exit avoids showing placeholder image while event isn't loaded.
            return '';
        }

        if (this.event.image != null) {
            return this.event.image;
        } else {
            if (environment.useRestStack === true) {
                return this.imageHelper.getImageUrl(this.defaultImageUrlCrmHosted);
            } else {
                return this.imageHelper.getImageUrl(this.defaultImageUrlCrmHosted);
            }
        }
    }

    public registerForSessions(ave_eventallowmultiplesessionregistercode:string) {
        if(ave_eventallowmultiplesessionregistercode=="900000000")
        {
            if (this.sessionCartService.getSessionCartForEvent(this.readableEventId).length !== 0) {
                this.router.navigate([EventCheckoutRoutePaths.REGISTRATION], { queryParams: { id: this.readableEventId,Source:this.url } });
            } else {
                this.registerForAllSessions();
            }
        }
        else
        {
            if (this.sessionCartService.getSessionCartForEvent(this.readableEventId).length !== 0) {
                this.router.navigate([EventCheckoutRoutePaths.REGISTRATION], { queryParams: { id: this.readableEventId,Source:this.url } });
            } else {
            alert("please select a session below.");
            }
        }
    }

    public canUserRegister() {
        if (this.event.setRegistrationEndDate) {
            return new Date(Date.now()) < new Date(this.event.stopRegistrationDate);
        }
        return true;
    }

    private registerForAllSessions() {
        this.sessions.forEach(session => {
            this.sessionCartService.addSession(this.readableEventId, session.id,false);
        });

        this.sessionCartService.isOpen = true;
    }

    private async getEventAndSessionData(): Promise<void> {
        try {
            this.event = await this.activeEventService.getEvent(this.readableEventId).toPromise();
            var allsessions = await this.activeEventService.getSessions(this.readableEventId).toPromise();
            this.sessions=allsessions.filter(session=>Date.parse(session.endTimeUTC.toString())>Date.parse(new Date().toUTCString()));

            this.showSessions = this.sessions && this.sessions.length > 0;
            this.eventRouterService.emitSessions(this.sessions);

            this.formattedDate = this.formatStartDate();
        } catch (error) {
            this.error = error;
            console.error(error);
        }
    }

    private async setIsSessionCartAllowed(): Promise<void> {
        let hasSessions = this.sessions && this.sessions.length > 0;
        this.isSessionCartAllowed = this.event.allowCustomAgenda && hasSessions;
    }

    private async setIsLoadDateAndDescription(): Promise<void> {
        this.isLoadDateAndDescription = true;
    }

    public checkDateAndDescription(ave_eventeventownedbycode: string):Boolean{
        if(ave_eventeventownedbycode=="900000002")
        {
            return false;
        }
        else
        {
            return true;
        }
    }


    public splitUrl():string {
        var str=window.location.href.split("?")[1];
        let params={};
        let items=str.split("&"); 
        var arr,name,value; 
        for(var i = 0, l = items.length; i < l; i++){ 
            let arr=items[i].split("="); 
            params[arr[0]]=arr[1]; 
        }
        if(typeof(params["Source"])=="undefined")
        {
            params["Source"]="undefined"; 
        }
        return params["Source"];
    }

    public checkEventNotLive(msevtmgt_publishstatus: string):Boolean{
        if(msevtmgt_publishstatus=="100000000" || msevtmgt_publishstatus=="100000001" || msevtmgt_publishstatus=="100000002")
        {
            let errorMessage = 'Event registration failed.';
            let errorCode = "EventIsDraftReadyToGoLiveInProgress";
            this.error = new LocalizableError(errorMessage, errorCode);
            return true;
        }
        else if(msevtmgt_publishstatus=="100000004")
        {
            let errorMessage = 'Event registration failed.';
            let errorCode = "EventIsCancelled";
            this.error = new LocalizableError(errorMessage, errorCode);
            return true;
        }
        else if(msevtmgt_publishstatus=="100000006")
        {
            let errorMessage = 'Event registration failed.';
            let errorCode = "EventIsCompleted";
            this.error = new LocalizableError(errorMessage, errorCode);
            return true;
        }
        return false;
    }

    public checkCETShow(type: string):Boolean{
        if(type=="900000002")
        {
            return false;
        }
        return true;
    }
}

export enum EventQueryParameterNames {
    ReadableEventId = "id",
    SpeakerId = "speakerId"
}

export enum EventDetailSections {
    Sessions = "sessions",
    SessionTracks = "session-tracks",
    Speakers = "speakers",
    PassInformation = "pass-information"
}
